import React from 'react';
import { PasswordResetPage } from '../components/Auth-Designer';

const PasswordResetPageWrapper = () => {
  return <PasswordResetPage />;
};

export default PasswordResetPageWrapper;